import { memo } from 'react';
import { EApplicantOfferPGKeys } from 'api-paths-cas';
import { TableCellProps } from '../../../types';
import { Flex } from '@chakra-ui/react';
import { defaultHeaderRenderer } from '../../headers';
import { IColumn } from '../../types';
import { getDays } from '../helpers';

const Formatter = memo(function formatter(cellProps: TableCellProps) {
  return (
    <Flex height="100%" width="100%" flexDirection={'column'}>
      {getDays(cellProps.row.applicantLastUpdatedAt)}
    </Flex>
  );
});

export const ApplicantLastUpdatedColumn = (): IColumn => ({
  item: {
    key: EApplicantOfferPGKeys.APPLICANT_LAST_UPDATED_AT,
    name: 'Last Updated',
    headerRenderer: defaultHeaderRenderer,
    width: 'minmax(128px, 1fr)',
    sortable: true,
    formatter: Formatter,
  },
  visible: () => true,
});
